var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.01523C0 1.38551 0.510508 0.875 1.14023 0.875H12.8598C13.4887 0.875 14 1.38551 14 2.01523C14 2.27773 13.9098 2.53203 13.743 2.73438L9.1875 8.32617V12.2418C9.1875 12.7285 8.79102 13.125 8.3043 13.125C8.10469 13.125 7.91055 13.0566 7.75469 12.909L5.22539 10.9266C4.96563 10.7188 4.8125 10.4043 4.8125 10.0707V8.32617L0.256293 2.73438C0.0905352 2.53203 0 2.27773 0 2.01523ZM1.50281 2.1875L5.97734 7.67812C6.07305 7.7957 6.125 7.94336 6.125 8.09375V9.96406L7.875 11.3531V8.09375C7.875 7.94336 7.92695 7.7957 8.02266 7.67812L12.4961 2.1875H1.50281Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter.ba4bc972f6dff1cd2c55e7cef04da0a5.svg";